import React, { ReactNode } from 'react';
import { ToggleWrapper } from './ToggleWrapper';
import { ToggledFeature } from './featureToggleService';

export function SendDocumentsViaEmailToggleWrapper(
  props: {
    children: ReactNode,
  }
) {
  return (
    <ToggleWrapper feature={ToggledFeature.SEND_DOCUMENTS_VIA_EMAIL}>
      {props.children}
    </ToggleWrapper>
  )
}
